<div
  [ngClass]="{ 'daterangepicker--disabled': disabled, 'daterangepicker--has-error': hasError }"
  class="relative control-preview"
  (click)="picker.open()"
>
  <input-v2
    [formControl]="dateControl"
    class="daterangepicker special-control"
    [readonly]="true"
    [prependSrc]="'assets/img/calendar-v2-icon.svg'"
    [placeholder]="(title ? title : 'realizationTerm') | translate"
  />

  <mat-date-range-input [rangePicker]="picker">
    <input matStartDate (dateChange)="updateStartDate($event)" [formControl]="startInput" />
    <input matEndDate (dateChange)="updateEndDate($event)" [formControl]="endInput" />
  </mat-date-range-input>

  <span
    *ngIf="dateControl?.value && !disabled && clearable"
    (click)="resetValue(); $event.stopPropagation()"
    aria-hidden="true"
    class="ng-clear"
  >
    ×
  </span>
</div>

<mat-date-range-picker #picker />
